/**
 * 可图 3.0 Omni（kling-v3-omni）manifest
 * 数据来源：image.json field_map
 * 特点：清晰度 1K/2K/4K（独立，不与比例联动）；比例不带真实像素；参考图上限 6
 */
import type { ImageModelConfig } from '../../types';

export const kling3Omni: ImageModelConfig = {
  id: '01KKDFPWWQFKTNWMY7TXABXV49',
  displayName: '可图 3.0 Omni',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    resolution: '2K', // 接口 resolution.default
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [
    { label: '标清 1K', value: '1K' },
    { label: '高清 2K', value: '2K' },
    { label: '超清 4K', value: '4K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label

  qualityOptions: [],

  toggles: {},

  limits: {
    maxRefImages: 6, // 接口 field_map.ref_images.max
  },
};
